import { useRootStore } from "store";

export const useDevmodeTrigger = () => {
    const { appStore } = useRootStore();


    const handleClick = (e: React.MouseEvent<any>) => {
        const isCtrlOrCmd = e.ctrlKey || e.metaKey;
        if (isCtrlOrCmd) {
            appStore.setDevelopmentMode(!appStore.devMode);
        }
      };
    return { handleClick };
};